import React from "react";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { modalActions } from "../../store/Modal.store";
import { getRegMachineLimit } from "../Service/EndPoints";
const BtnAddTask: React.FC<{ icon?: any; className?: string }> = ({
  icon,
  className,
}) => {
  const dispatch = useAppDispatch();
  const machines = useAppSelector((state) => state.machines.machines);
  const LIMIT = useAppSelector((state) => state.machines.LIMIT);

const isDisabled= machines.length>= LIMIT ?true:false;
  const onOpenModal = () => {
    dispatch(modalActions.openModalCreateTask());
  };
  return (
    <button
    
      disabled={isDisabled}
      onClick={onOpenModal}
      className={`${className} text-[#E4EFF9] ${isDisabled?"bg-gray-400":""}   ${icon ? "hover:bg-[#06B4FF] bg-transparent hover:text-[#000000]" : ""}
      ${!icon ? "bg-[#06B4FF]" : ""} w-[252px] h-[48px] inline-flex items-center px-4 py-2    `}
    >
      {icon ? (
        <span className=" mr-4">
          <svg
            width="21"
            height="18"
            viewBox="0 0 21 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.5918 0.494629H4.5918C2.5218 0.494629 0.841797 2.17463 0.841797 4.24463V11.2446C0.841797 13.3146 2.5218 14.9946 4.5918 14.9946H7.8718C7.8718 14.9946 7.8718 15.0546 7.8718 15.0846C7.7418 15.6846 7.4818 16.1546 7.2418 16.4946H6.6118C6.2018 16.4946 5.8618 16.8346 5.8618 17.2446C5.8618 17.6546 6.2018 17.9946 6.6118 17.9946H14.6118C15.0218 17.9946 15.3618 17.6546 15.3618 17.2446C15.3618 16.8346 15.0218 16.4946 14.6118 16.4946H13.9818C13.7418 16.1546 13.4818 15.6846 13.3418 15.0846C13.3418 15.0546 13.3418 15.0246 13.3418 14.9946H16.6218C18.6918 14.9946 20.3718 13.3146 20.3718 11.2446V4.24463C20.3718 2.17463 18.6918 0.494629 16.6218 0.494629H16.5918ZM11.8618 15.4046C11.9418 15.7746 12.0718 16.1446 12.2318 16.4946H8.9618C9.1218 16.1446 9.2518 15.7846 9.3318 15.4046C9.3618 15.2646 9.3918 15.1346 9.4018 14.9946H11.7918C11.8118 15.1346 11.8318 15.2746 11.8618 15.4046ZM18.8418 11.2446C18.8418 12.4846 17.8318 13.4946 16.5918 13.4946H4.5918C3.3518 13.4946 2.3418 12.4846 2.3418 11.2446V4.24463C2.3418 3.00463 3.3518 1.99463 4.5918 1.99463H16.5918C17.8318 1.99463 18.8418 3.00463 18.8418 4.24463V11.2446Z"
              fill="url(#paint0_linear_142_344)"
            />
            <path
              d="M13.5918 10.4946H7.5918C7.1818 10.4946 6.8418 10.8346 6.8418 11.2446C6.8418 11.6546 7.1818 11.9946 7.5918 11.9946H13.5918C14.0018 11.9946 14.3418 11.6546 14.3418 11.2446C14.3418 10.8346 14.0018 10.4946 13.5918 10.4946Z"
              fill="#E4EFF9"
            />
            <defs>
              <linearGradient
                id="paint0_linear_142_344"
                x1="10.6068"
                y1="0.494629"
                x2="10.6068"
                y2="17.9946"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#E0F0FF" />
                <stop offset="1" stop-color="#C1E1FF" />
              </linearGradient>
            </defs>
          </svg>
        </span>
      ) : null}
      New Machine
    </button>

    // <button
    //   className={`${className} text-[#E4EFF9]  ${!icon? ("hover:bg-[#E4EFF9] hover:text-[#000000]"):"hover:bg-[#06B4FF] hover:text-[#E4EFF9]"}  bg-[#06B4FF] w-[252px] h-[48px]`}
    //   onClick={onOpenModal}
    // >

    //   <span> New Machine</span>
    // </button>
  );
};

export default BtnAddTask;
